import React, { Component } from "react";
import { GridRow, GridColumn } from "arv-reactcomponents";
import { Anchor } from "arv-extends";
import { FOOTER } from "npmlinks-constants";

const {
  PRIVACY_POLICY: {
    COPYRIGHT_TEXT,
    COPYRIGHT_URL,
    POLICY,
    POLICY_URL,
    TNC,
    TNC_URL,
  },
} = FOOTER;
class PrivacyPolicy extends Component {
  componentDidMount() {
    console.log(this);
  }
  render() {
    return (
      <GridRow className="wc-footerpolicycontainer">
        <GridColumn className="wc-footerpolicycol">
          <div className="wc-footerpolicycol-item wc-footerpolicycol-rights">
            <Anchor.component
              to={COPYRIGHT_URL}
              href={COPYRIGHT_URL}
              className="wc-footerpolicy-anchor"
            >
              {COPYRIGHT_TEXT}
            </Anchor.component>
          </div>
          <div className="wc-footerpolicycol-item wc-footerpolicycol-policy">
            <Anchor.component
              to={POLICY_URL}
              href={POLICY_URL}
              className="wc-footerpolicy-anchor"
            >
              {POLICY}
            </Anchor.component>
          </div>
          <div className="wc-footerpolicycol-item wc-footerpolicycol-tnc">
            <Anchor.component
              to={TNC_URL}
              href={TNC_URL}
              className="wc-footerpolicy-anchor"
            >
              {TNC}
            </Anchor.component>
          </div>
        </GridColumn>
      </GridRow>
    );
  }
}

export default PrivacyPolicy;
